// extracted by mini-css-extract-plugin
export var closeButton = "_q8-2";
export var closeButtonIcon = "_q8-3";
export var lightboxContent = "_q8-1";
export var lightboxOverlay = "_q8-0";